import config from "../config/config.ts";
import { ProductIdentifier } from "@common/utils/identifyProduct.ts";
import { ProductSkeleton } from "@common/types/ProductTypes.ts";
import { SubscriptionType } from "@common/enums/SubscriptionTypeEnum.ts";

export const HEADER_BACKGROUND_IMAGE = '/images/houses.jpeg';

const resolveProduct = (): ProductSkeleton => {
    const identifier = new ProductIdentifier(config?.productOverride);
    return identifier.getProductFromHost(window.location.hostname);
};

// The hostname cannot change without a full page load, so this only needs resolving once.
const PRODUCT = resolveProduct();

export const PRODUCT_TITLE = PRODUCT.displayName;

/** Whether buyers on this product pay per lead against a budget, or buy leads in prepaid packages. */
export const PRODUCT_SUBSCRIPTION_TYPE: SubscriptionType = PRODUCT.buyerSubType;
